import { CollectionItem } from "@/Common/Models/CollectionItem";
import { Guid } from "@/Common/Models/Guid";
import { IntegrationBusFactory } from "@/Common/Modularity/IntegrationBus/IntegrationBusFactory";

/** Payload for the GetFormsBlockingNoteApprovalRequest. */
type GetFormsBlockingNoteApprovalPayload = { patientContactId: Guid };
/** Request to get forms blocking note approval. */
const GetFormsBlockingNoteApprovalRequest = IntegrationBusFactory.createRequest<GetFormsBlockingNoteApprovalPayload, CollectionItem<string, string>[]>("GetFormsBlockingNoteApprovalRequest");

/** Payload for the GetFormsToSendOnNoteApprovalRequest. */
type GetFormsToSendOnNoteApprovalPayload = { patientContactId: Guid };
/** Request to get forms to send on note approval. */
const GetFormsToSendOnNoteApprovalRequest = IntegrationBusFactory.createRequest<GetFormsToSendOnNoteApprovalPayload, CollectionItem<string, string>[]>("GetFormsToSendOnNoteApprovalRequest");

export {
    GetFormsBlockingNoteApprovalPayload,
    GetFormsBlockingNoteApprovalRequest,
    GetFormsToSendOnNoteApprovalPayload,
    GetFormsToSendOnNoteApprovalRequest
};
